<script setup lang="ts">

import Translator from "@/utils/common/Translator.ts";
import {QSelect, useDialogPluginComponent} from "quasar";
import ListPresenter from "@/utils/common/ListPresenter.ts";
import {StringUtils} from "@/utils/common/StringUtils.ts";
import {Ref, ref} from "vue";
import ListViewUtils from "@/utils/common/ListViewUtils.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";

const props = defineProps({
  presenter: {
    type: ListPresenter,
    required: true
  }
});

const {dialogRef, onDialogCancel} = useDialogPluginComponent()
const sortFieldsValue = props.presenter.sortFieldsValue;
const qSelectOfSortFields = ref<QSelect | null>(null);
const displayedSortOptions: Ref<Record<string, string>[]> = ref([]);

function onUpdateSortFields(newValue: Record<string, string>[]) {
  sortFieldsValue.value = newValue;
  props.presenter.fetchPlace().orderBy = StringUtils.toCSVLineWithSep(',', newValue.map(l => l.value).filter(Boolean));
  qSelectOfSortFields.value?.updateInputValue('', false);
}

function onFilterInSortOption(val, update) {
  update(() => ListViewUtils.filterSortOption(val, displayedSortOptions, props.presenter.sortOptions),
    ref => {
      if (val !== '' && ref.options.length > 0) {
        ref.setOptionIndex(-1)
        ref.moveOptionSelection(1, true)
      }
    })
}
</script>

<template>
  <q-dialog persistent ref="dialogRef" @keydown.esc="onDialogCancel">
    <q-card class="tw-flex tw-flex-col tw-shadow-none tw-bg-namaBackground-bright-light !tw-max-w-[50vw] dark:tw-text-white dark:tw-bg-namaBackground-bright-dark">
      <q-bar
        class="tw-flex-none tw-h-fit tw-min-h-8 tw-text-namaFontColor-input-light tw-bg-[#CED4DA] tw-px-2 tw-py-[6px] tw-flex tw-justify-between dark:tw-bg-[#212529] dark:tw-text-white">
        <div>{{ Translator.translateId('sortFields') }}</div>
        <q-btn dense flat @click="onDialogCancel" :title="Translator.translateId( 'close')" class="tw-h-fit">
          <NamaIcon default-icon="nm-win-close"/>
        </q-btn>
      </q-bar>
      <q-select
        ref="qSelectOfSortFields"
        outlined multiple dense use-input options-dense use-chips
        :model-value="sortFieldsValue"
        @update:model-value="onUpdateSortFields"
        @filter="onFilterInSortOption"
        :placeholder="Translator.translateId('sortOn')"
        :options="displayedSortOptions"
        class="nama-criteria-field-input nama-customize-dense-input mobile:tw-w-full tw-m-5"
        input-class="tw-bg-transparent focus:tw-ring-0 focus:tw-shadow-none focus:tw-border-none dark:tw-text-white
              dark:tw-placeholder-gray-300 header-search-in-popup-input"
        options-selected-class="tw-pl-[6px] tw-pr-[3px] tw-text-base tw-font-normal tw-border-b-black tw-bg-primary-light dark:tw-bg-primary-dark tw-text-white"
      />
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
